export default __webpack_public_path__ + "static/media/52.3826d30e.jpg";